import React, { useMemo, useCallback } from 'react';
import propTypes from 'prop-types';
import { UiTable } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink, Link } from 'react-router-dom';

export function LocationsTable({ loading, locations, onDeleteLocation, onViewNotes }) {
  function resolveData(data) {
    return data.map(location => {
      const newLocation = {
        ...location,
        fullAddress: `${location.address} ${location.address2 || ''}`,
      };

      return newLocation;
    });
  }

  const onDelete = useCallback(location => {
    return () => onDeleteLocation(location);
  }, []);
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Type',
        accessor: 'type',
        width: 160,
        Cell: row => (
          <Link className="edit-link" to={`/locations/edit/${row.original.id}`}>
            {row.value}
          </Link>
        ),
      },
      {
        Header: 'Address',
        accessor: 'fullAddress',
        Cell: row => (
          <Link className="edit-link" to={`/locations/edit/${row.original.id}`}>
            {row.value}
          </Link>
        ),
      },
      {
        Header: 'City',
        accessor: 'city',
        Cell: row => <div className="has-text-centered">{row.value}</div>,
        width: 180,
      },
      {
        Header: 'State',
        accessor: 'state',
        Cell: row => <div className="has-text-centered">{row.value}</div>,
        width: 120,
      },
      {
        Header: 'License Number',
        accessor: 'licenseNumber',
        Cell: row => <div className="has-text-centered">{row.value}</div>,
        // width: 120,
      },
      {
        Header: 'License Expiration',
        accessor: 'licenseExpiredDate',
        Cell: row => <div className="has-text-centered">{row.value}</div>,
        // width: 120,
      },
      {
        Header: 'Notes',
        accessor: 'id',
        sortable: false,
        width: 100,
        resizable: false,
        Cell: row => (
          <a
            className="edit-link"
            onClick={() => onViewNotes(row.original)}
            style={{ cursor: 'pointer' }}
          >
            Notes
          </a>
        ),
      },
      {
        Header: '',
        accessor: 'id',
        sortable: false,
        width: 62,
        resizable: false,
        Cell: row => (
          <MuiDropdown
            isAlign="right"
            renderTrigger={
              <Button isColor="white">
                <span className="icon">
                  <FontAwesomeIcon
                    icon={['fal', 'ellipsis-v']}
                    className="has-text-grey"
                    size="lg"
                  />
                </span>
              </Button>
            }
          >
              <MuiDropdownItem tag={NavLink} to={`/locations/edit/${row.value}`}>
                Edit
              </MuiDropdownItem>
              <MuiDropdownItem tag="a" onClick={onDelete(row.original)}>
                Archive
              </MuiDropdownItem>
          </MuiDropdown>
        ),
      },
    ],
    []
  );

  return (
    <UiTable
      className="locations-table"
      columns={tableColumns}
      loading={loading}
      data={locations}
      title="Location"
      emptyTo="/locations/add"
      // eslint-disable-next-line
      resolveData={resolveData}
      getTheadThProps={(_state, _rowInfo, column) => ({
        className: ['type', 'fullAddress'].includes(column.id)
          ? 'has-text-left'
          : '',
      })}
      toNext="/people"
      toPrev="/business"
      hideNext
      hidePrev
    />
  );
}

LocationsTable.propTypes = {
  loading: propTypes.bool.isRequired,
  locations: propTypes.arrayOf(propTypes.object).isRequired,
  onDeleteLocation: propTypes.func.isRequired,
  onViewNotes: propTypes.func.isRequired,
};
